import { useState } from "react";
import { X } from "lucide-react";
import { ASSETS, GALLERY } from "@/data/content";
import { t } from "@/data/texts";
import { img } from "@/data/images";
import { Reveal } from "@/components/effects/Effects";

const ROT = [-6, 4, -3, 7, -5, 3, -8, 5, -2, 6];

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="galerie"
      className="relative border-b border-white/10"
      style={{
        background:
          "radial-gradient(ellipse at center, #1a120b 0%, #0a0705 70%), #0a0705",
      }}
      data-testid="gallery-section"
    >
      {/* cork/dirt texture overlay */}
      <div className="absolute inset-0 opacity-[0.08] bg-noise pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 py-20 lg:py-28 relative z-10">
        <Reveal>
          <p className="text-xs tracking-[0.4em] text-nv uppercase mb-3">{t("gallery.kicker", GALLERY.kicker)}</p>
          <h2 className="font-head text-3xl sm:text-4xl text-neutral-100 mb-2 vhs-glitch">{t("gallery.title", GALLERY.title)}</h2>
          <p className="text-sm text-neutral-500 mb-12">{t("gallery.sub", GALLERY.sub)}</p>
        </Reveal>

        <div className="flex flex-wrap justify-center gap-6 sm:gap-8" data-testid="polaroid-board">
          {ASSETS.polaroids.map((orig, i) => {
            const src = img(`polaroid${i + 1}`, orig);
            return (
            <button
              key={i}
              onClick={() => setActive(src)}
              data-testid={`polaroid-${i + 1}`}
              className="vhs-btn group relative bg-[#e8e3d6] p-2 pb-8 shadow-2xl hover:z-20 transition-transform duration-300 hover:scale-105 hover:!rotate-0"
              style={{ transform: `rotate(${ROT[i % ROT.length]}deg)`, boxShadow: "0 18px 40px rgba(0,0,0,0.7)" }}
            >
              {/* pin */}
              <span className="absolute -top-2 left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-red-700 shadow-md z-10" />
              <img
                src={src}
                alt={`Nalezená fotografie ${i + 1}`}
                loading="lazy"
                className="w-40 sm:w-48 h-52 sm:h-60 object-cover"
                style={{ filter: "sepia(0.25) contrast(1.05) brightness(0.92)" }}
              />
              <span className="absolute bottom-2 inset-x-0 text-center font-head text-[10px] tracking-widest text-[#5a5346]">
                No. {String(i + 1).padStart(2, "0")}
              </span>
            </button>
            );
          })}
        </div>
      </div>

      {/* Lightbox */}
      {active && (
        <div
          className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-6"
          onClick={() => setActive(null)}
          data-testid="polaroid-lightbox"
        >
          <button className="absolute top-6 right-6 text-neutral-300 hover:text-nv" onClick={() => setActive(null)}>
            <X className="w-8 h-8" />
          </button>
          <div className="bg-[#e8e3d6] p-3 pb-12 max-w-lg" onClick={(e) => e.stopPropagation()}>
            <img src={active} alt="Nalezená fotografie" className="w-full object-contain max-h-[70vh]" />
          </div>
        </div>
      )}
    </section>
  );
}
